<app-segov-sigepo-portal-body>

  <app-segov-sigepo-header-section [Title]="title" [RouteStack]="RouteStack">
  </app-segov-sigepo-header-section>

  <div class="default-spacing-title" style="padding-top: 2rem; padding-bottom: 2rem;">
    <h3>Acessibilidade</h3>
    <h4>Contraste</h4>
    <p><img style="background-color: white; border-radius: 50%;" width="24px" src="icons/contrast-fill-reverse.svg" alt="Ícone de contraste padrão"/> Alto Contraste</p>
    <p><img style="background-color: black; border-radius: 50%;" width="24px" src="icons/contrast-fill.svg" alt="Ícone de contraste padrão"/> Contraste padrão</p>

    <h4>Teclas de acesso</h4>
    <p>Teclas de acesso são um recurso de navegação que permitem a você navegar neste web site com o seu teclado. Informações mais detalhadas sobre as teclas de acesso podem ser encontradas em Diretrizes de Acessibilidade do W3C.</p>

    <h4>Teclas de acesso disponíveis</h4>
    <ul type="none" style="padding-left: 0;">
      <li>ALT + 1 - Conteúdo (Foco no conteúdo principal da página)</li>
      <li>ALT + 2 - Menu (Foco no menu superior)</li>
      <li>ALT + 3 - Busca (Redireciona para a pesquisa do jornal)</li>
      <li>ALT + 4 - Mapa do site (Foco nas informações do rodapé)</li>
    </ul>
  </div>
</app-segov-sigepo-portal-body>
